//---Only create axios + attach interceptors, delegate refresh to authApi.---//
import axios, { AxiosError, type AxiosRequestConfig } from "axios";
import { getAccessToken, setAccessToken } from "../auth/tokenStore";
import { refreshToken } from "./authApi";

interface RetryConfig extends AxiosRequestConfig {
  _retry?: boolean;
}

// * Ensure API base is defined *
const apiBase = import.meta.env.VITE_API_BASE_URL;
if (!apiBase) {
  throw new Error("VITE_API_BASE_URL is not defined!");
}

const api = axios.create({
  baseURL: apiBase,
  withCredentials: true,
});

// Attach token
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` } as any;
  }
  return config;
});

// Refresh on 401
api.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as RetryConfig;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const newToken = await refreshToken();
        setAccessToken(newToken);
        original.headers = { ...original.headers, Authorization: `Bearer ${newToken}` };
        return api(original);
      } catch (refreshErr) {
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(error);
  }
);

export default api;

